"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var changes_1 = require("../changes/");
/**
 * User pressed Enter in an editor
 *
 * Enter on an empty block inside a blockquote exit the blockquote.
 */
function onEnter(event, editor, opts, next) {
    var value = editor.value;
    var startBlock = value.startBlock;
    if (!utils_1.getCurrentBlockquote(opts)(value)) {
        return next();
    }
    if (startBlock.text.length !== 0) {
        return next();
    }
    // Block is empty, we exit the blockquote
    event.preventDefault();
    changes_1.unwrapBlockquote(opts, editor);
    return true;
}
exports.default = onEnter;
//# sourceMappingURL=onEnter.js.map